import React, { useState, useMemo } from 'react';
import Meta from 'src/components/Meta';
import { useGaEventPageView } from 'src/utils/gaEvent';
import styled from 'styled-components';
import { PageContainer, Poppins, Spacer } from 'src/common';
import Button from 'src/components/form/Button';
import { useAuth } from 'src/state/auth';
import { Invites, Requests } from './comps';
import { OrganisationCreateModalV2, WorkspaceCreateModal } from 'src/components/modals';
import { useCache } from 'src/graphql/useCache';
import OrgTable from 'src/components/OrgTable';
import Input from 'src/components/form/Input';
import useLocalStorage from 'src/hooks/useLocalStorage';

const Div = styled(PageContainer)`
  .head {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    grid-gap: 10px;

    &__buttons {
      display: flex;
      gap: 14px;
      grid-gap: 24px;
      align-items: center;

      &__switch {
        display: flex;
        align-items: center;
        gap: 10px;
        margin-left: auto;
        cursor: pointer;
        user-select: none;
        margin-right: 10px;
      }
    }
  }

  ${({ theme }) => theme.breakpoints.down('md')} {
    .head {
      &__buttons {
        flex-direction: column;
        gap: 14px;
        &__switch {
          margin-right: 0;
        }
      }
    }
  }
`;

const OrganisationHierarchyPage = () => {
  const [isOrganisationCreateModal, setIsOrganisationCreateModal] = useState(false);
  const [isWorspaceCreateModal, setIsWorspaceCreateModal] = useState(false);
  const [showArchived, setShowArchived] = useLocalStorage('showArchived', false);
  const { profile, flatOrganisations } = useAuth();
  const { refetchQuery } = useCache();
  useGaEventPageView('Cydea | Organisations');

  const resetCache = () => refetchQuery({ include: ['profile', 'flatOrganisations'] });

  return (
    <>
      <Meta title={`Cydea | Organisations`} feedbackScript />
      {isOrganisationCreateModal && <OrganisationCreateModalV2 onClose={() => setIsOrganisationCreateModal(false)} />}
      {isWorspaceCreateModal && <WorkspaceCreateModal onClose={() => setIsWorspaceCreateModal(false)} />}
      <Div>
        <div className="head">
          <Poppins px={32} weight={600}>
            Organisations
          </Poppins>

          <div className="head__buttons">
            <div className="head__buttons__switch" onClick={() => setShowArchived(!showArchived)}>
              <Input checked={showArchived} className="switch" type="checkbox" />
              <Poppins color="davysGrey">Show archived workspaces</Poppins>
            </div>
            {profile?.permissions.canCreateOrganisation && (
              <Button secondary onClick={() => setIsOrganisationCreateModal(true)} $constWidth={300}>
                + CREATE ORGANISATION
              </Button>
            )}
            {profile?.permissions.canCreateWorkspace && (
              <Button secondary onClick={() => setIsWorspaceCreateModal(true)} $constWidth={300}>
                + CREATE WORKSPACE
              </Button>
            )}
          </div>
        </div>

        <Invites onSuccess={resetCache} />
        <Requests onSuccess={resetCache} />
        <Spacer $px={32} />
        <OrgTable data={flatOrganisations || []} showArchived={showArchived} />
      </Div>
    </>
  );
};

export default OrganisationHierarchyPage;
